(ns dre.modals.db
  (:require
   [dre.modals.annotator.views :as annotator]
   [dre.modals.admin.feed.events :as admin-feed]
   [dre.modals.admin.feed.views :as admin.feed]
   [dre.modals.admin.help.events :as admin-help]
   [dre.modals.admin.help.views :as admin.help]
   [dre.modals.app-settings.views :as app-settings]
   [dre.modals.app-settings.events :as e-app-settings]
   [dre.modals.ds-stats.views :as ds-stats]
   [dre.modals.my-searches.signals.views :as signals]
   [dre.modals.my-searches.signals.events :as e-signals]
   [dre.modals.my-searches.tags.views :as tags]
   [dre.modals.my-searches.tags.events :as e-tags]
   [dre.modals.question-answering.views :as qa]
   [dre.modals.question-answering.events :as e-qa]
   [dre.modals.search.export.views :as export]
   [dre.modals.search.export.events :as e-export]
   [dre.modals.search.share.views :as share]
   [dre.modals.search.share.events :as e-share]
   [dre.modals.surveys.views :as surveys]
   [dre.modals.surveys.events :as e-surveys]
   [dre.modals.ai-summarization-usage.events :as e-ai-summarization-usage]
   [dre.modals.ai-summarization-usage.views :as ai-summarization-usage]
   [dre.modals.usage.events :as e-usage]
   [dre.modals.usage.views :as usage]))


(def registry
  [{:id :ds-stats
    :init-fx :dre.modals.ds-stats.events/init
    :view ds-stats/view}
   {:id :annotator/config
    :view annotator/view}
   {:id :app-settings
    :view app-settings/view
    :init-fx ::e-app-settings/init}
   {:id :admin.help/add-help-topic
    :view admin.help/add-help-topic
    :init-fx ::admin-help/init}
   {:id :admin.help/add-confluence-article
    :view admin.help/add-confluence-article
    :init-fx ::admin-help/init}
   {:id :admin.help/delete-help-topic
    :view admin.help/delete-help-topic
    :init-fx ::admin-help/init}
   {:id :admin.help/preview-help-topic
    :view admin.help/preview-help-topic
    :init-fx ::admin-help/init}
   {:id :admin.help/delete-confluence-article
    :view admin.help/delete-confluence-article
    :init-fx ::admin-help/init}
   {:id :admin.feed/add-new-feed
    :view admin.feed/add-new-feed
    :init-fx ::admin-feed/init}
   {:id :admin.feed/edit-feed
    :view admin.feed/edit-feed
    :init-fx ::admin-feed/init}
   {:id :admin.feed/delete-feed
    :view admin.feed/delete-feed
    :init-fx ::admin-feed/init}
   {:id :my-searches.signals/delete-confirm
    :view signals/confirm-delete-view
    :init-fx ::e-signals/init-delete}
   {:id :my-searches.signals/edit
    :view signals/edit-view
    :init-fx ::e-signals/init-edit}
   {:id :my-searches.tags/delete-confirm
    :view tags/confirm-delete-view
    :init-fx ::e-tags/init}
   {:id :my-searches.tags/edit
    :view tags/edit-view
    :init-fx ::e-tags/init}
   {:id :my-searches.tags/copy
    :view tags/copy-view
    :init-fx ::e-tags/init}
   {:id :question-answering/feedback
    :view qa/view
    :init-fx ::e-qa/init}
   {:id :search.export/export
    :view export/export-view
    :init-fx ::e-export/init}
   {:id :search.share/share
    :view share/share-view
    :init-fx ::e-share/init}
   {:id :surveys/survey
    :view surveys/view
    :init-fx ::e-surveys/init
    :close-fx ::e-surveys/dismiss}
   {:id :usage/usage
    :view usage/view
    :init-fx ::e-usage/init}
   {:id :usage/ai-summarization-usage
    :view ai-summarization-usage/view
    :init-fx ::e-ai-summarization-usage/init}])


(def index (into {} (map (juxt :id identity)) registry))
